import React from 'react';
import { View, Text, StyleSheet, ViewStyle, TextStyle } from 'react-native';
import Icon from 'react-native-vector-icons/MaterialIcons';

export interface ChatEmptyStateProps {
  /** 图标名称 */
  icon?: string;
  /** 标题 */
  title?: string;
  /** 副标题 */
  subtitle?: string;
  /** 图标大小 */
  iconSize?: number;
  /** 图标颜色 */
  iconColor?: string;
  /** 容器样式 */
  containerStyle?: ViewStyle;
  /** 标题样式 */
  titleStyle?: TextStyle;
  /** 副标题样式 */
  subtitleStyle?: TextStyle;
}

/**
 * 聊天空状态组件
 * 
 * 当没有消息时显示的占位内容
 * 
 * @example
 * ```tsx
 * <ChatEmptyState
 *   icon="chat-bubble-outline"
 *   title="暂无消息"
 *   subtitle="发送第一条消息开始聊天"
 * />
 * ```
 */
export const ChatEmptyState: React.FC<ChatEmptyStateProps> = ({
  icon = 'chat-bubble-outline',
  title = '暂无消息',
  subtitle,
  iconSize = 80,
  iconColor = '#ccc',
  containerStyle,
  titleStyle,
  subtitleStyle,
}) => {
  return (
    <View style={[styles.container, containerStyle]}>
      <Icon name={icon} size={iconSize} color={iconColor} />
      {title && (
        <Text style={[styles.title, titleStyle]}>{title}</Text>
      )}
      {subtitle && (
        <Text style={[styles.subtitle, subtitleStyle]}>{subtitle}</Text>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    paddingVertical: 60,
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#333',
    marginTop: 16,
    marginBottom: 8,
  },
  subtitle: {
    fontSize: 14,
    color: '#666',
    textAlign: 'center',
  },
});
